import React from 'react';
import { LeftSlotWrapper, RightSlotWrapper, TextWrapper, } from './buttonStyle.js';
export const ButtonContent = ({ rightSlot, children, leftSlot, size, }) => (React.createElement(React.Fragment, null,
    leftSlot && (React.createElement(LeftSlotWrapper, { "data-test-specifier": "left-slot", size: size }, leftSlot)),
    children && (React.createElement(TextWrapper, { "data-test-specifier": "text", size: size }, children)),
    rightSlot && (React.createElement(RightSlotWrapper, { "data-test-specifier": "right-slot", size: size }, rightSlot))));
//# sourceMappingURL=ButtonContent.js.map